/**
 * Command Schema Types — re-exported from @lokascript/intent
 */

export type { CommandSchema, RoleSpec } from '@lokascript/intent';
export { defineCommand, defineRole, getRoleSpec } from '@lokascript/intent';
